import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Swal from "sweetalert2";
import api from "../api/api"; // <-- your configured Axios instance

const AcademicYearPost = () => {
  const [formData, setFormData] = useState({
    name: "",
    start_date: "",
    end_date: "",
    is_active: false,
  });

  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate loading for 3 seconds
    setTimeout(async () => {
      try {
        const response = await api.post("/academic-years/", formData); // adjust endpoint if needed
        Swal.fire({
          icon: "success",
          title: "Academic Year Added!",
          text: `Academic year ${response.data.name} created successfully.`,
          background: "#e3f2fd",
          confirmButtonColor: "#1976d2",
        });

        // ✅ Dispatch event so context and dropdown update instantly
        window.dispatchEvent(new Event("academic-year-updated"));

        setFormData({
          name: "",
          start_date: "",
          end_date: "",
          is_active: false,
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Failed to Add",
          text: error.response?.data?.detail || "Something went wrong!",
          background: "#ffebee",
          confirmButtonColor: "#d32f2f",
        });
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 6,
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant="h5"
        textAlign="center"
        fontWeight="bold"
        mb={2}
        color="primary"
      >
        Add Academic Year
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Academic Year (e.g. 2024/2025)"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Start Date"
          name="start_date"
          type="date"
          value={formData.start_date}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          label="End Date"
          name="end_date"
          type="date"
          value={formData.end_date}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />

        <FormControlLabel
          control={
            <Checkbox
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              color="primary"
            />
          }
          label="Set as Active Academic Year"
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            mt: 3,
            height: 48,
            bgcolor: "#FFD700",
            color: "#4B3621",
            fontWeight: "bold",
            "&:hover": { bgcolor: "#E6BE00" },
          }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={26} color="inherit" /> : "Add Academic Year"}
        </Button>
      </form>
    </Box>
  );
};

export default AcademicYearPost;



// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   TextField,
//   Typography,
//   FormControlLabel,
//   Checkbox,
// } from "@mui/material";
// import Swal from "sweetalert2";
// import api from "../api/api"; // <-- your configured Axios instance

// const AcademicYearPost = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     start_date: "",
//     end_date: "",
//     is_active: false,
//   });

//   const [loading, setLoading] = useState(false);

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   // Handle submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Simulate loading for 3 seconds
//     setTimeout(async () => {
//       try {
//         const response = await api.post("/academic-years/", formData); // adjust endpoint if needed
//         Swal.fire({
//           icon: "success",
//           title: "Academic Year Added!",
//           text: `Academic year ${response.data.name} created successfully.`,
//           background: "#e3f2fd",
//           confirmButtonColor: "#1976d2",
//         });
//         setFormData({
//           name: "",
//           start_date: "",
//           end_date: "",
//           is_active: false,
//         });
//       } catch (error) {
//         Swal.fire({
//           icon: "error",
//           title: "Failed to Add",
//           text: error.response?.data?.detail || "Something went wrong!",
//           background: "#ffebee",
//           confirmButtonColor: "#d32f2f",
//         });
//       } finally {
//         setLoading(false);
//       }
//     }, 3000);
//   };

//   return (
//     <Box
//       sx={{
//         maxWidth: 400,
//         mx: "auto",
//         mt: 6,
//         p: 3,
//         borderRadius: 3,
//         boxShadow: 3,
//         bgcolor: "background.paper",
//       }}
//     >
//       <Typography
//         variant="h5"
//         textAlign="center"
//         fontWeight="bold"
//         mb={2}
//         color="primary"
//       >
//         Add Academic Year
//       </Typography>

//       <form onSubmit={handleSubmit}>
//         <TextField
//           label="Academic Year (e.g. 2024/2025)"
//           name="name"
//           value={formData.name}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           required
//         />
//         <TextField
//           label="Start Date"
//           name="start_date"
//           type="date"
//           value={formData.start_date}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           InputLabelProps={{ shrink: true }}
//           required
//         />
//         <TextField
//           label="End Date"
//           name="end_date"
//           type="date"
//           value={formData.end_date}
//           onChange={handleChange}
//           fullWidth
//           margin="normal"
//           InputLabelProps={{ shrink: true }}
//           required
//         />

//         <FormControlLabel
//           control={
//             <Checkbox
//               name="is_active"
//               checked={formData.is_active}
//               onChange={handleChange}
//               color="primary"
//             />
//           }
//           label="Set as Active Academic Year"
//         />

//         <Button
//           type="submit"
//           variant="contained"
//           fullWidth
//           sx={{
//             mt: 3,
//             height: 48,
//             bgcolor: "#FFD700",
//             color: "#4B3621",
//             fontWeight: "bold",
//             "&:hover": { bgcolor: "#E6BE00" },
//           }}
//           disabled={loading}
//         >
//           {loading ? <CircularProgress size={26} color="inherit" /> : "Add Academic Year"}
//         </Button>
//       </form>
//     </Box>
//   );
// };

// export default AcademicYearPost;